import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/navlayer/navlayer.query.gql"
import type {
  NavLayerQuery,
  NavLayerQueryVariables,
} from "@/v2-backoffice-client/navlayer/__types__/navlayer.query"

type Options = QueryHookOptions<NavLayerQuery, NavLayerQueryVariables>

export function useNavLayerQuery(options?: Options) {
  return useQuery<NavLayerQuery, NavLayerQueryVariables>(query, options)
}
